import { PENDING, FULFILLED, REJECTED } from "redux-promise-middleware";
import {
  FETCH_COMPANY_PROFILE_TYPES,
  FETCH_COMPANY_PROFILE_TYPE,
  CREATE_COMPANY_PROFILE_TYPE,
  UPDATE_COMPANY_PROFILE_TYPE,
  DELETE_COMPANY_PROFILE_TYPE,
} from "../actions/companyProfileType";

const SINGLE_DATA_INITIAL_STATE = {
  data: {},
  error: null,
  loading: false,
};
const MULTI_DATA_INITIAL_STATE = {
  data: [],
  error: null,
  loading: false,
};

export function companyProfileTypes(
  state = MULTI_DATA_INITIAL_STATE,
  { type, payload }
) {
  switch (type) {
    case `${FETCH_COMPANY_PROFILE_TYPES}_${PENDING}`:
      return Object.assign({}, state, { loading: true, error: null });
    case `${FETCH_COMPANY_PROFILE_TYPES}_${FULFILLED}`:
      return Object.assign({}, state, payload.data, {
        loading: false,
        error: null,
      });
    case `${FETCH_COMPANY_PROFILE_TYPES}_${REJECTED}`:
      return Object.assign({}, state, {
        loading: false,
        error: payload,
      });
    default:
      return state;
  }
}

export function companyProfileType(
  state = SINGLE_DATA_INITIAL_STATE,
  { type, payload }
) {
  switch (type) {
    case `${FETCH_COMPANY_PROFILE_TYPE}_${PENDING}`:
      return Object.assign({}, state, { loading: true, error: null });
    case `${FETCH_COMPANY_PROFILE_TYPE}_${FULFILLED}`:
      return Object.assign(
        {},
        state,
        { data: payload.data },
        { loading: false, error: null }
      );
    case `${FETCH_COMPANY_PROFILE_TYPE}_${REJECTED}`:
      return Object.assign({}, state, {
        loading: false,
        error: payload,
      });
    default:
      return state;
  }
}

export function createCompanyProfileType(
  state = SINGLE_DATA_INITIAL_STATE,
  { type, payload }
) {
  switch (type) {
    case `${CREATE_COMPANY_PROFILE_TYPE}_${PENDING}`:
      return Object.assign({}, state, { loading: true, error: null });
    case `${CREATE_COMPANY_PROFILE_TYPE}_${FULFILLED}`:
      return Object.assign(
        {},
        state,
        { data: payload.data },
        { loading: false, error: null }
      );
    case `${CREATE_COMPANY_PROFILE_TYPE}_${REJECTED}`:
      return Object.assign({}, state, {
        loading: false,
        error: payload,
      });
    default:
      return state;
  }
}

export function updateCompanyProfileType(
  state = SINGLE_DATA_INITIAL_STATE,
  { type, payload }
) {
  switch (type) {
    case `${UPDATE_COMPANY_PROFILE_TYPE}_${PENDING}`:
      return Object.assign({}, state, { loading: true, error: null });
    case `${UPDATE_COMPANY_PROFILE_TYPE}_${FULFILLED}`:
      return Object.assign(
        {},
        state,
        { data: payload.data },
        { loading: false, error: null }
      );
    case `${UPDATE_COMPANY_PROFILE_TYPE}_${REJECTED}`:
      return Object.assign({}, state, {
        loading: false,
        error: payload,
      });
    default:
      return state;
  }
}

export function deleteCompanyProfileType(
  state = SINGLE_DATA_INITIAL_STATE,
  { type, payload }
) {
  switch (type) {
    case `${DELETE_COMPANY_PROFILE_TYPE}_${PENDING}`:
      return Object.assign({}, state, { loading: true, error: null });
    case `${DELETE_COMPANY_PROFILE_TYPE}_${FULFILLED}`:
      return Object.assign(
        {},
        state,
        { data: payload.data },
        { loading: false, error: null }
      );
    case `${DELETE_COMPANY_PROFILE_TYPE}_${REJECTED}`:
      return Object.assign({}, state, {
        loading: false,
        error: payload,
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/companyProfileType.js